import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput } from 'shared/components'

import * as styles from './styles'

import { getOptionLabel, getOptionValue } from './helpers'

const TeamsFiltersComponent = ({ form, loadSportTypes }) => (
  <Form form={form}>
    <Grid>
      <Row css={styles.filtersWrapper}>
        <Col xs={12} sm={4}>
          <FormInput
            name="search"
            icon="search"
            placeholder="Search by name..."
            css={styles.phoneSpace}
            grayBg
          />
        </Col>
        <Col xs={12} sm={4}>
          <FormInput
            fluid
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="sportTypes"
            placeholder="Sport"
            loadOptions={loadSportTypes}
            oldInput
            iconOptioned
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

TeamsFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  loadSportTypes: PropTypes.func.isRequired,
}

export default TeamsFiltersComponent
